import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Stan',
      fields: {
        room_service_visible: {
          label: 'Obsługa pokoju/stolika widoczna',
        },
        has_room_service: {
          label: 'Obsługa pokoju/stolika',
        },
      },
    },
    settings: {
      title: 'Ustawienia',
      table_number: {
        label: 'Pokaż numer stolika',
      },
    },
    locations: {
      title: 'Lokalizacje',
    },
  },
  form: {
    google_place: {
      label: 'Nazwa',
      placeholder: 'Nazwa w Google Maps',
    },
    type: {
      label: 'Typ',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Obsługa pokoju',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Obsługa stolika',
      },
    },
    name: {
      label: 'Nazwa lokalizacji',
      placeholder: 'Podaj nazwę lokalizacji zrozumiałą dla klienta',
    },
    street_name: {
      label: 'Ulica',
      placeholder: 'Nazwa ulicy',
    },
    street_number: {
      label: 'Numer budynku',
      placeholder: 'Numer budynku',
    },
    city: {
      label: 'Miasto',
      placeholder: 'Miasto',
    },
    zip_code: {
      label: 'Kod pocztowy',
      placeholder: 'Kod pocztowy',
    },
  },
  fields: {
    id: 'ID',
    type: 'Typ',
    name: 'Nazwa',
    address: 'Adres',
    is_active: 'Aktywna',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Obsługa pokoju',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Obsługa stolika',
  },
  modals: {
    delete_location: {
      title: 'Czy na pewno?',
      description: 'Spowoduje to usunięcie lokalizacji „{{name}}"',
    },
  },
  buttons: {
    save: 'Zapisz',
    delete: 'Usuń',
  },
  toasts: {
    failed_to_load_locations: 'Nie udało się załadować lokalizacji, odśwież stronę',
    failed_to_create_location: 'Nie udało się utworzyć lokalizacji',
    failed_to_toggle_location: 'Nie udało się zmienić dostępności lokalizacji',
    failed_to_delete_location: 'Nie udało się usunąć lokalizacji',
    location_got_created: 'Lokalizacja została pomyślnie utworzona',
    location_got_deleted: 'Lokalizacja została usunięta',
    saving_success: 'Zapisano pomyślnie',
    saving_error: 'Zapisywanie nie powiodło się',
  },
};
